import React from 'react'
import styled, { keyframes } from 'styled-components'
import { withBreakpoints } from 'react-breakpoints'

import { FiLoader } from 'react-icons/fi'

import CloudinaryResource from '../../../infrastructure/components/CloudinaryResource'
import traedeBlackLogo from '../../../assets/images/logo_black.svg'
import SeedImage from './seed.png'

import InputField from '../components/InputField'

import { connect } from 'react-redux'
import {
  registerRetailer,
  requestCompleteForgotPassword,
  requestForgotPassword,
  requestLogin,
  requestRegister,
} from '../actions'
import { msg } from '../../shared'
import querystring from 'qs'
import isObject from 'lodash/isObject'
import { reduxForm } from 'redux-form'

import qs from 'querystring'
import { getBrandData } from '../api'

import { getPublicBrand } from '../../shop/api'
import { resolveCloudinaryResource } from '../../../infrastructure/components/CloudinaryResource'

const LoginForm = ({
  currentBreakpoint,
  dispatch,
  history,
  location,
  match: { params },
}) => {
  const [brand, setBrand] = React.useState(null)

  const query = querystring.parse(location.search.substr(1))
  const [brandId, setBrandId] = React.useState(query.brand)
  const [source, setSource] = React.useState(query.source)
  const token = params.code
  const [show, setShow] = React.useState(params.mode || 'login')

  // Load brand
  const [logo, setLogo] = React.useState(null)
  const [tagLine, setTagLine] = React.useState(null)
  const [backgroundColor, setBackgroundColor] = React.useState(null)
  const [backgroundImage, setBackgroundImage] = React.useState(null)

  const [hasBrand, setHasBrand] = React.useState(true)
  const [hasLoadedSettings, setHasLoadedSettings] = React.useState(false)
  const [hasLoadedPublicBrand, setHasLoadedPublicBrand] = React.useState(false)

  React.useEffect(() => {
    if (!brandId) {
      if (hasLoadedPublicBrand) {
        setBackgroundColor('rgba(248,235,236,1)')
        setTagLine(
          'Empowering fashion & lifestyle brands <span>world wide</span>'
        )
        setHasBrand(false)
      }

      setHasLoadedSettings(true)
      return
    }

    getBrandData(brandId).then(response => {
      if (response.error) {
        setHasLoadedSettings(true)
        return
      }

      const { logo, tagLine, backgroundColor, backgroundImage } =
        response.payload

      logo !== null && setLogo(logo)
      tagLine !== null && setTagLine(tagLine || null)
      setBackgroundColor(backgroundColor || null)
      backgroundImage !== null &&
        setBackgroundImage(
          `url(${resolveCloudinaryResource({ id: backgroundImage }).url})`
        )

      setHasLoadedSettings(true)
    })
  }, [
    brandId,
    hasLoadedPublicBrand,
    setLogo,
    setTagLine,
    setBackgroundColor,
    setHasBrand,
    setHasLoadedSettings,
  ])

  const [submitting, setSubmitting] = React.useState(false)

  // Sign in

  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')

  const login = React.useCallback(
    event => {
      event.preventDefault()

      if (submitting) {
        return
      }

      setSubmitting(true)

      dispatch(requestLogin(email, password)).catch(response => {
        setSubmitting(false)

        msg(
          'error',
          'Sorry either the e-mail or password was wrong. Please try again or click "Forgot Password?" to reset your password'
        )
      })
    },
    [email, password, submitting, setSubmitting, dispatch]
  )

  // Forgot password

  const forgotPassword = React.useCallback(
    event => {
      event.preventDefault()

      if (submitting) {
        return
      }

      setSubmitting(true)

      dispatch(requestForgotPassword(email))
        .then(response => {
          setSubmitting(false)

          if (response.error) {
            msg('error', 'Something went wrong')
          }

          msg(
            'success',
            'A password reminder has been sent to your email. Go check it!'
          )

          setShow('login')
        })
        .catch(response => {
          setSubmitting(false)

          msg('error', 'Something went wrong')
        })
    },
    [email, submitting, setSubmitting, setShow]
  )

  const isMobile = ['mobile', 'tablet'].includes(currentBreakpoint)

  // Change password

  const [newPassword, setNewPassword] = React.useState('')
  const [newPasswordConfirmation, setNewPasswordConfirmation] =
    React.useState('')

  const changePassword = React.useCallback(
    event => {
      event && event.preventDefault()

      setSubmitting(true)

      dispatch(
        requestCompleteForgotPassword(
          newPassword,
          newPasswordConfirmation,
          token
        )
      ).then(response => {
        setSubmitting(false)

        if (response.error) {
          return
        }

        msg('success', 'Your password was changed successfully!')
        setShow('login')
      })
    },
    [
      newPassword,
      newPasswordConfirmation,
      token,
      dispatch,
      setShow,
      setSubmitting,
    ]
  )

  const back = React.useCallback(() => {
    brandId ? history.push(`/login?brand=${brandId}`) : history.push('/login')
  }, [history, setShow])

  const register = React.useCallback(() => {
    history.push('/register')
  }, [history])

  const registerFreemium = React.useCallback(() => {
    window.location.href = 'https://traede.com/retailer'
  }, [history])

  // Custom brand

  const customerRegistrationApp = React.useMemo(() => {
    return brand
      ? (brand.apps || []).find(app => app.app === 'Customer Registration')
      : null
  }, [brand])

  React.useEffect(() => {
    getPublicBrand().then(res => {
      if (res.status === 200) {
        setHasLoadedSettings(false)
        setBrand(res.payload.brand)
        setBrandId(res.payload.brand.id)
      }

      setHasLoadedPublicBrand(true)
    })
  }, [setBrand, setBrandId, setHasLoadedPublicBrand, setHasLoadedSettings])

  const hasLeftContent =
    tagLine !== null || backgroundColor !== null || backgroundImage !== null

  // Registration

  const [registerCustomerType, setRegisterCustomerType] =
    React.useState('brand')
  const [registerShowHelpModal, setRegisterShowHelpModal] =
    React.useState(false)

  // Brand

  const [registerEmail, setRegisterEmail] = React.useState('')

  // Retailer

  const [registerCompanyName, setRegisterCompanyName] = React.useState('')
  const [registerContactPerson, setRegisterContactPerson] = React.useState('')

  const submitRegister = React.useCallback(
    event => {
      event.preventDefault()

      setSubmitting(true)

      switch (registerCustomerType) {
        case 'brand':
          dispatch(requestRegister(registerEmail, source)).then(response => {
            setSubmitting(false)

            if (!response.error) {
              setShow('login')

              msg(
                'success',
                'You are now registered. Check your inbox for an invitation mail to get started! :-)'
              )

              if (process.env !== 'local') {
                var trackingPixel = $(
                  '<img height="1" width="1" alt="" style="display:none" ' +
                    'src="https://www.facebook.com/tr?ev=6028866154225&amp;cd[value]=0.00&' +
                    'amp;cd[currency]=DKK&amp;noscript=1" />'
                )
                trackingPixel.appendTo($('body'))
              }
            }
          })
          return

        case 'retailer':
          dispatch(
            registerRetailer(
              registerCompanyName,
              registerContactPerson,
              registerEmail
            )
          ).then(response => {
            setSubmitting(false)
            setShow('login')

            if (!response.error) {
              msg('success', 'Your sign up request has been received.')
            }
          })
          return
      }
    },
    [
      dispatch,
      registerCustomerType,
      registerEmail,
      registerCompanyName,
      registerContactPerson,
      source,
      setShow,
      setSubmitting,
    ]
  )

  if (!hasLoadedPublicBrand || !hasLoadedSettings) {
    return (
      <Loader>
        <FiLoader
          className="fa-spin"
          size={50}
          style={{ verticalAlign: 'middle' }}
        />
      </Loader>
    )
  }

  return (
    <Wrapper>
      {!isMobile && hasLeftContent && (
        <Teaser style={{ backgroundColor, backgroundImage }}>
          <div
            style={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}
          >
            <div>
              {tagLine !== null && (
                <Headline dangerouslySetInnerHTML={{ __html: tagLine }} />
              )}
            </div>

            {!hasBrand && <Seed src={SeedImage} />}
          </div>
        </Teaser>
      )}

      <Content className={isMobile ? 'mobile' : undefined}>
        {show === 'login' && (
          <div>
            {customerRegistrationApp && (
              <TopRight onClick={register}>
                Not registered? <strong>Click here!</strong>
              </TopRight>
            )}
            {!hasBrand && !customerRegistrationApp && (
              <TopRight onClick={registerFreemium}>
                Not a part of Traede? <strong>Click here!</strong>
              </TopRight>
            )}
            <LogoContainer>
              <CloudinaryResource
                brandId={brand ? brand.id : null}
                id={logo}
                presets="logo_login"
                fallback="logo_black_v2"
              />
            </LogoContainer>

            <h1>Sign in</h1>
            <form onSubmit={login}>
              <InputField
                type="email"
                name="email"
                placeholder="E-mail"
                disabled={submitting}
                onChange={event => setEmail(event.target.value)}
                value={email}
              />

              <InputField
                type="password"
                name="password"
                placeholder="Password"
                disabled={submitting}
                onChange={event => setPassword(event.target.value)}
                value={password}
                data-private="redact"
              />

              <button type="submit">
                {submitting && (
                  <FiLoader
                    className="fa-spin"
                    size={14}
                    style={{ verticalAlign: 'middle', marginRight: 10 }}
                  />
                )}
                Enter
              </button>

              <button
                style={{ marginTop: 15 }}
                onClick={() => setShow('forgot-password')}
                type="button"
                className="transparent"
              >
                Forgot password?
              </button>
            </form>
          </div>
        )}

        {show === 'forgot-password' && token === undefined && (
          <div>
            <LogoContainer>
              <CloudinaryResource
                brandId={brand ? brand.id : null}
                id={logo}
                presets="logo_login"
                fallback="logo_black_v2"
              />
            </LogoContainer>

            <h1>Reset password</h1>

            <form onSubmit={forgotPassword}>
              <InputField
                type="email"
                placeholder="E-mail"
                disabled={submitting}
                onChange={event => setEmail(event.target.value)}
                value={email}
              />

              <button type="submit">
                {submitting && (
                  <FiLoader
                    className="fa-spin"
                    size={14}
                    style={{ verticalAlign: 'middle', marginRight: 10 }}
                  />
                )}
                Reset password
              </button>

              <button
                style={{ marginTop: 15 }}
                onClick={() => setShow('login')}
                type="button"
                className="transparent"
              >
                Go back
              </button>
            </form>
          </div>
        )}

        {show === 'forgot-password' && token !== undefined && (
          <div>
            <LogoContainer>
              <CloudinaryResource
                brandId={brand ? brand.id : null}
                id={logo}
                presets="logo_login"
                fallback="logo_black_v2"
              />
            </LogoContainer>

            <h1>Change password</h1>

            <form onSubmit={changePassword}>
              <InputField
                type="password"
                placeholder="Password"
                disabled={submitting}
                onChange={event => setNewPassword(event.target.value)}
                value={email}
              />
              <InputField
                type="password"
                placeholder="Confirm password"
                disabled={submitting}
                onChange={event =>
                  setNewPasswordConfirmation(event.target.value)
                }
                value={password}
              />

              <button type="submit">
                {submitting && (
                  <FiLoader
                    className="fa-spin"
                    size={14}
                    style={{ verticalAlign: 'middle', marginRight: 10 }}
                  />
                )}
                Change password
              </button>

              <button
                style={{ marginTop: 15 }}
                onClick={back}
                type="button"
                className="transparent"
              >
                Go back
              </button>
            </form>
          </div>
        )}

        {show === 'registration' && (
          <div>
            <LogoContainer>
              <CloudinaryResource
                brandId={brand ? brand.id : null}
                id={logo}
                presets="logo_login"
                fallback="logo_black_v2"
              />
            </LogoContainer>

            <h1>Register</h1>

            <form onSubmit={submitRegister}>
              <div
                className="btn-group"
                style={{ display: 'flex', marginBottom: 20 }}
              >
                <button
                  type="button"
                  className={
                    registerCustomerType === 'brand'
                      ? 'btn secondary'
                      : 'btn transparent'
                  }
                  onClick={() => setRegisterCustomerType('brand')}
                >
                  Brand
                </button>
                <button
                  type="button"
                  className={
                    registerCustomerType === 'retailer'
                      ? 'btn secondary'
                      : 'btn transparent'
                  }
                  onClick={() => setRegisterCustomerType('retailer')}
                >
                  Retailer
                </button>
              </div>

              {registerCustomerType === 'brand' && (
                <>
                  <InputField
                    type="email"
                    placeholder="Your e-mail"
                    disabled={submitting}
                    onChange={event => setRegisterEmail(event.target.value)}
                    value={registerEmail}
                  />

                  <button type="submit">
                    {submitting && (
                      <FiLoader
                        className="fa-spin"
                        size={14}
                        style={{ verticalAlign: 'middle', marginRight: 10 }}
                      />
                    )}

                    {source ? 'Register' : 'Register as brand'}
                  </button>
                </>
              )}

              {registerCustomerType === 'retailer' && (
                <>
                  <InputField
                    type="text"
                    placeholder="Company name"
                    disabled={submitting}
                    onChange={event =>
                      setRegisterCompanyName(event.target.value)
                    }
                    value={registerCompanyName}
                  />

                  <InputField
                    type="text"
                    placeholder="Contact person"
                    disabled={submitting}
                    onChange={event =>
                      setRegisterContactPerson(event.target.value)
                    }
                    value={registerContactPerson}
                  />

                  <InputField
                    type="email"
                    placeholder="E-mail address"
                    disabled={submitting}
                    onChange={event => setRegisterEmail(event.target.value)}
                    value={registerEmail}
                  />

                  <button type="submit">
                    {submitting && (
                      <FiLoader
                        className="fa-spin"
                        size={14}
                        style={{ verticalAlign: 'middle', marginRight: 10 }}
                      />
                    )}

                    {source ? 'Register' : 'Register as retailer'}
                  </button>
                </>
              )}
            </form>
          </div>
        )}
      </Content>
    </Wrapper>
  )
}

const Seed = styled.img`
  width: 50%;
  max-height: 70vh;
  margin: 0 auto;
`

const TopRight = styled.div`
  cursor: pointer;
  position: absolute;
  top: 25px;
  right: 25px;

  color: #3b3233;
  font-family: 'Lato', sans-serif;
  font-size: 15px;
  letter-spacing: 0.25px;

  strong {
    padding-left: 4px;
    font-weight: 800;
  }
`

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    padding: 50px 15vw;
  }

  &.mobile > div {
    padding: 50px 0;
  }

  h1 {
    color: #3b3233;
    font-size: 26px;
    font-family: 'Domine', serif;
    margin-bottom: 40px;
    text-align: center;
  }

  form {
    width: 100%;
    min-width: 320px;

    button {
      width: 100%;
      height: 50px;
      border-radius: 50px;
      text-align: center;
      font-family: 'Lato', sans-serif;
      border: 0;
      background-color: #3b3233;
      color: #fff;
      letter-spacing: 1px;
      font-weight: 600;
      font-size: 13px;
      outline: 0;
      border: 0;
      box-shadow: none !important;
      outline: 0 !important;

      &.transparent {
        color: #3b3233;
        background-color: transparent;
      }

      &:focus,
      &:active,
      &:hover {
        color: #fff;
        background-color: #3b3233;
        background: #3b3233;
      }

      &.secondary {
        background-color: #fff;
        color: #000;
        font-weight: 200;
        border: 1px solid #3b3133;

        &:focus,
        &:active,
        &:hover {
          color: #000;
          background-color: #fff;
          background: #fff;
          border: 1px solid #3b3133;
        }
      }
    }
  }
`

const Headline = styled.div`
  color: rgba(0, 0, 0, 0.4);
  width: 80%;
  font-size: 38px;
  font-family: 'Domine', serif;
  line-height: 145%;
  letter-spacing: 0.75px;

  span {
    color: rgba(0, 0, 0, 0.7);
  }
`

const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  max-width: 250px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  position: relative;

  > img {
    max-width: 250px;
    width: auto;
  }
`

const Teaser = styled.div`
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

  > div > div {
    padding: 50px 80px;
  }
`

const FadeIn = keyframes`
  from {
    opacity: 0;
    filter: blur(5px);
  }

  to {
    opacity: 1;
    filter: blur(0);
  }
`

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  will-change: opacity, transform;
  animation: ${FadeIn} 0.75s;
  animation-iteration-count: 1;

  > * {
    flex: 1 0 0px;
    flex-grow: 1;
    flex-basis: 0;
  }
`

const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  color: #3b3233;
`

// export default connect()(withBreakpoints(LoginForm))

const formKey = 'login_form'

export default connect((state, ownProps) => {
  const form = state.form
  // Query should always be object (T502)
  const {
    match: { params },
    location: { search },
  } = ownProps
  const query = querystring.parse(search.substr(1))

  const checkQueryParamsAndFormState = property => {
    if (query[property]) {
      return query[property]
    }
    // (T502)
    if (
      isObject(form[formKey]) &&
      isObject(form[formKey].values) &&
      form[formKey].values[property]
    ) {
      return form[formKey].values[property]
    }
    return undefined
  }

  const source = checkQueryParamsAndFormState('source')

  return {
    source,
    redirect: query.redirect || '/',
  }
})(connect()(withBreakpoints(LoginForm)))
